import React from "react";
import styled from "styled-components";
import {Divider} from "../../../constants/assets/containers";
import {Typography} from "@mui/material";
import {red,grey,blue} from "sushiweb/tokens/color";
import { getDashboardUrl } from "../../../views/Home";

const PlatformFeeDetailsCard = ({ data }) => {

  const rateCardUrl = `${getDashboardUrl()}/admin/rules_dashboard/view/DriverPlatformFeeRateCard/${data.rate_card_id}`;

    return (
      data && Object.keys(data).length > 0 ?
        <React.Fragment>
          <Container>
            <AccountingRow entry={data.total_fee} />
            <AccountingRow entry={data.upfront_fee} neg/>
            { data.instalments?.map((item, index) => <AccountingRow entry={item} key={index} neg/>) }
            <AccountingRow entry={data.pending_fee} magnify/>
            <CardFooter data={data} />
          </Container>
          <Typography variant="body1" color={grey.z600} marginY={2}>Ratecard Mapped: <a href={rateCardUrl} target="_blank">{data.rate_card_id}</a></Typography>
        </React.Fragment>
          : <React.Fragment></React.Fragment>
    );
};

const AccountingRow = ({entry, neg=false, magnify=false}) => {
  if(!entry || !entry.title) return <React.Fragment></React.Fragment>;
  else return (
    <React.Fragment>
      <CardRow>
        <Typography variant="h6" fontWeight={magnify ? 600 : 400}
                    color={grey.z800}>{entry.title}</Typography>
        <Typography variant="h6" fontWeight={magnify ? 600 : 400}
                    color={neg ? red.z500 : grey.z800}>{neg ? "-" : ""}&#8377;{entry.amount ? entry.amount : 0}</Typography>
      </CardRow>
      <Divider variant="inset" margin="dense" color={grey.z200} />
    </React.Fragment>
  );
}

const CardFooter = ({ data }) => {
  if(!data.pending_fee || !data.pending_fee.amount){
    return <React.Fragment></React.Fragment>
  }

  if(data.is_instalment_based) {
    return <FooterNote>
      <Typography variant="h8" fontSize="13px" color={grey.z700}>Pending fees will be collected from weekly payout in instalments.</Typography>
    </FooterNote>
  } else {
    return <FooterNote>
      <Typography variant="h8" fontSize="13px" color={grey.z700}>
        {data.instalment_fee_percentage}% of your weekly earnings will be collected towards pending fees from payout.
      </Typography>
    </FooterNote>
  }
}

const Container = styled.div`
    width: 450px;
    border-radius: 16px;
    background-color: white;
    padding: 16px;
`;
const CardRow = styled.div`
    display: flex;
    margin: auto;
    justify-content: space-between;
    padding: 16px 12px;
`
const FooterNote = styled.div`
    margin: 16px 0;
    padding: 10px 16px;
    background-color: ${blue.z100};
    border-radius: 8px;
    font-size: smaller;
`


export default PlatformFeeDetailsCard;
